/**
 * Media image size presets
 */
export const MediaImageSize = {
  ResourceIcon: 'resource-icon',
  CohortIcon: 'cohort-icon',
  ModuleIcon: 'module-icon',
  ContactIcon: 'contact-icon',
  EmailImage: 'email-image',
  Custom: 'custom',
} as const;

export type MediaImageSizeType =
  (typeof MediaImageSize)[keyof typeof MediaImageSize];

/**
 * The variant for media image paths.
 */
export const MediaImagePathVariant = {
  /**
   * The original image.
   */
  Original: 'original',

  /**
   * The thumbnail image.
   */
  Thumbnail: 'thumbnail',
} as const;

export type MediaImagePathVariantType =
  (typeof MediaImagePathVariant)[keyof typeof MediaImagePathVariant];

/**
 * Size dimensions
 */
export interface Size {
  width: number;
  height: number;
}
